import { Box, styled, Typography } from '@mui/material';

import BFACMBgLoginPage from '../../../assets/img/BFACM_bg-login.webp';
import BFACMBgLPage from '../../../assets/img/BFACM_bg-lpage.webp';

export const BoxBackgroundImageStyled = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'isFormPage' &&
    prop !== 'isLoginPage' &&
    prop !== 'isOnboardingAdvancedSteps',
})(({ theme, isFormPage, isLoginPage, isOnboardingAdvancedSteps }) => ({
  backgroundImage: `url(${isLoginPage ? BFACMBgLoginPage : BFACMBgLPage})`,
  backgroundPosition: 'center',
  width: isFormPage ? '50%' : '100%',
  height: isFormPage ? '100%' : 'fill-available',
  minHeight: isFormPage ? 'auto' : '650px',
  backgroundSize: 'cover',
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',

  [theme.breakpoints.up('xxl')]: {
    width: isOnboardingAdvancedSteps && '532px',
  },
  [theme.breakpoints.up('xxxxl')]: {
    width: isOnboardingAdvancedSteps && '640px',
  },
}));

export const BackgroundMobileImageStyled = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isFormPage',
})(({ theme, isFormPage }) => ({
  width: '100%',
  height: isFormPage ? '216px' : 'fill-available',
  minHeight: '216px',
  objectFit: 'cover',

  [theme.breakpoints.up('md')]: {
    height: isFormPage && '416px',
    minHeight: '416px',
  },
}));

export const LandingPageText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isFormPage',
})(({ theme, isFormPage }) => ({
  width: '328px',
  color: theme.palette.colors.onHomePageBackground,
  fontSize: '34px',
  fontWeight: 700,
  lineHeight: 1.18,
  letterSpacing: 'normal',
  marginInline: 'auto',
  padding: '16px 0',
  display: isFormPage && 'none',

  [theme.breakpoints.up('sm')]: {
    width: '417px',
  },
  [theme.breakpoints.up('md')]: {
    width: '550px',
  },
  [theme.breakpoints.up('lg')]: {
    display: isFormPage && 'block',
    width: 'auto',
    maxWidth: !isFormPage && '650px',
    color: theme.palette.colors.onImageBackground,
    fontSize: '40px',
    lineHeight: 1.15,
    margin: 0,
    padding: 0,
  },
  [theme.breakpoints.up('xxl')]: {
    maxWidth: !isFormPage && '626px',
  },
  [theme.breakpoints.up('xxxxl')]: {
    maxWidth: !isFormPage && '967px',
  },
}));

export const CardContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isFormPage',
})(({ theme, isFormPage }) => ({
  backgroundColor: theme.palette.colors.homePageBackground,
  width: '100%',
  height: !isFormPage && 'fill-available',
  display: 'flex',
  flexDirection: 'column',
}));
